import {HiyaVerHost} from 'hiya-common/src/constant'

import {channel_type_enum} from 'hiya-common/src/reducers/commonTypes'
import {config_item} from './interface'

export {
  channel_bind_status_enum as bind_status_enum,
  channel_type_enum,
} from 'hiya-common/src/reducers/commonTypes'

export const rules = {
  [channel_type_enum.PayerMaxFawry]: {
    // 最少10位；最多10位； 第一位不为0； http://wiki.xunlei.cn/pages/viewpage.action?pageId=113918448
    phone: {
      min: 10,
      max: 10,
      pattern: /\d{10}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
    },
  },

  [channel_type_enum.阿联酋Payby]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=113918535
    // 不为空
    phone: {
      min: 1,
      pattern: /\d$/g,
      formatfn: (val) => val.replace(/[^\d]/g, ''), // 必须输入数字
    },
    payee_name: {
      min: 1,
      max: 100,
      pattern: /^(?=.{1,100}$)[^ ].*[^ ]$|^[^ ]$/,
      isTrim: false,
      // formatfn: (val) => val.replace(/[^A-Za-z ]/g, ''),
    },
  },
  [channel_type_enum.埃及Vodafone]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=113918788
    // 最少10位；最多10位；第一位不为0；前2位是10
    phone: {
      min: 10,
      max: 10,
      pattern: /^10\d{8}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
      message: 'Vodafone报错',
    },
    payee_name: {
      min: 1,
      max: 100,
      pattern: /^(?=.{1,100}$)[^ ].*[^ ]$|^[^ ]$/,
      isTrim: false,
      // formatfn: (val) => val.replace(/[^A-Za-z ]/g, ''),
    },
  },
  [channel_type_enum.埃及Etisalat]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=113918796
    // 最少10位；最多10位；第一位不为0；前2位是11
    phone: {
      min: 10,
      max: 10,
      pattern: /^11\d{8}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
      message: 'Etisalat报错',
    },
    payee_name: {
      min: 1,
      max: 100,
      pattern: /^(?=.{1,100}$)[^ ].*[^ ]$|^[^ ]$/,
      isTrim: false,
      // formatfn: (val) => val.replace(/[^A-Za-z ]/g, ''),
    },
  },
  [channel_type_enum.埃及Orane]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=113918801
    // 最少10位；最多10位；第一位不为0；前2位是12
    phone: {
      min: 10,
      max: 10,
      pattern: /^12\d{8}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
      message: 'Orange报错',
    },
    payee_name: {
      min: 1,
      max: 100,
      pattern: /^(?=.{1,100}$)[^ ].*[^ ]$|^[^ ]$/,
      isTrim: false,
      // formatfn: (val) => val.replace(/[^A-Za-z ]/g, ''),
    },
  },
  // [channel_type_enum.埃及Orane]: {
  // 埃及-Aman【手机号&姓名&邮箱】 本期先不做
  //   // http://wiki.xunlei.cn/pages/viewpage.action?pageId=113918801
  //   // 最少10位；最多10位；第一位不为0；
  //   phone: {
  //     max: 10,
  //     pattern: /\d{10}$/g,
  //     formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
  //   },
  // },
  [channel_type_enum.印尼DANA]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=113911117
    // 最少8位； 最多13位； 第一位不为0； 第一位需为8；
    phone: {
      min: 8,
      max: 13,
      pattern: /^8\d{7,12}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
    },
    payee_name: {
      min: 1,
      max: 100,
      pattern: /^(?=.{1,100}$)[^ ].*[^ ]$|^[^ ]$/,
      isTrim: false,
      // formatfn: (val) => val.replace(/[^A-Za-z ]/g, ''),
    },
  },
  [channel_type_enum.印尼LinkAja]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=113917026
    // 最少8位；最多13位；第一位不为0；第一位需为8；
    phone: {
      min: 8,
      max: 13,
      pattern: /^8\d{7,12}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
    },
    // 小于45字符 支持“,”，不支持空格
    payee_name: {
      min: 1,
      max: 45,
      pattern: /^[A-Za-z,]{1,45}$/g,
      isTrim: true,
      formatfn: (val) => val.replace(/[^A-Za-z,]/g, ''),
    },
  },
  [channel_type_enum.印尼Shpee]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=113918461
    // 最少8位；最多13位；第一位不为0；第一位需为8；
    phone: {
      min: 8,
      max: 13,
      pattern: /^8\d{7,12}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
    },
  },
  [channel_type_enum.印尼OVO]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=113918474
    // 最少8位；最多13位；第一位不为0；第一位需为8；
    phone: {
      min: 8,
      max: 13,
      pattern: /^8\d{7,12}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
    },
    payee_name: {
      min: 1,
      max: 100,
      pattern: /^(?=.{1,100}$)[^ ].*[^ ]$|^[^ ]$/,
      isTrim: false,
      // formatfn: (val) => val.replace(/[^A-Za-z ]/g, ''),
    },
  },
  [channel_type_enum.印尼GoPay]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=113918484
    // 最少8位；最多13位；第一位不为0；第一位需为8；
    phone: {
      min: 8,
      max: 13,
      pattern: /^8\d{7,12}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
    },
    // 小于45个字符的英文名称
    payee_name: {
      min: 1,
      max: 45,
      pattern: /^[A-Za-z]{1,45}$/g,
      isTrim: true,
      formatfn: (val) => val.replace(/[^A-Za-z,]/g, ''),
    },
  },
  // 菲律宾GCash
  [channel_type_enum.GCash]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=113918505
    // 最少10位； 最多10位； 第一位不为0； 第一位需为9；
    phone: {
      min: 10,
      max: 10,
      pattern: /^9\d{9}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
    },
    // 小于100字符英文名 支持「大小写字母」「空格」「.」
    payee_name: {
      min: 1,
      max: 100,
      pattern: /^[A-Za-z\s.]{1,100}$/g,
      isTrim: false,
      formatfn: (val) => val.replace(/[^A-Za-z\s.]/g, ''),
    },
  },
  [channel_type_enum.菲律宾Coins]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=113918493
    // 最少10位；最多10位；第一位不为0；第一位需为9；
    phone: {
      min: 10,
      max: 10,
      pattern: /^9\d{9}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
    },
    // 小于100字符英文名 支持「大小写字母」「空格」「.」
    payee_name: {
      min: 1,
      max: 100,
      pattern: /^[A-Za-z\s.]{1,100}$/g,
      isTrim: false,
      formatfn: (val) => val.replace(/[^A-Za-z\s.]/g, ''),
    },
  },
  [channel_type_enum.菲律宾PayMaya]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=113918514
    // 最少10位；最多10位；第一位不为0；第一位需为9；
    phone: {
      min: 10,
      max: 10,
      pattern: /^9\d{9}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
    },
    // 小于100字符英文名 支持「大小写字母」「空格」「.」
    payee_name: {
      min: 1,
      max: 100,
      pattern: /^[A-Za-z\s.]{1,100}$/g,
      isTrim: false,
      formatfn: (val) => val.replace(/[^A-Za-z\s.]/g, ''),
    },
  },
  [channel_type_enum.菲律宾GrabPay]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=113918524
    // 最少10位；最多10位；第一位不为0；第一位需为9；
    phone: {
      min: 10,
      max: 10,
      pattern: /^9\d{9}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
    },
    // 小于100字符英文名 支持「大小写字母」「空格」「.」
    payee_name: {
      min: 1,
      max: 100,
      pattern: /^[A-Za-z\s.]{1,100}$/g,
      isTrim: false,
      formatfn: (val) => val.replace(/[^A-Za-z\s.]/g, ''),
    },
  },
  [channel_type_enum.泰国TrueMoney]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=113918808
    // 最少9位；最多9位； 第一位不为0；
    phone: {
      min: 9,
      max: 9,
      pattern: /\d{9}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
    },
    payee_name: {
      min: 1,
      max: 100,
      pattern: /^(?=.{1,100}$)[^ ].*[^ ]$|^[^ ]$/,
      isTrim: false,
      // formatfn: (val) => val.replace(/[^A-Za-z ]/g, ''),
    },
  },
  [channel_type_enum.马来西亚TouchnGo]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=113918810
    // 最少10位；最多11位；
    phone: {
      min: 10,
      max: 11,
      pattern: /\d{10,11}$/g,
      formatfn: (val) => val.replace(/[^\d]/g, ''),
    },
    payee_name: {
      min: 1,
      max: 100,
      pattern: /^(?=.{1,100}$)[^ ].*[^ ]$|^[^ ]$/,
      isTrim: false,
      // formatfn: (val) => val.replace(/[^A-Za-z ]/g, ''),
    },
  },
  [channel_type_enum.菲律宾Lazada]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=113918533
    // 最少10位；最多10位； 第一位不为0；第一位需为9;
    phone: {
      min: 10,
      max: 10,
      pattern: /^9\d{9}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
    },
  },
  [channel_type_enum.越南ninePay]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=120404734
    // 最少9位；最多9位； 第一位不为0；
    phone: {
      min: 9,
      max: 9,
      pattern: /\d{9}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
    },
  },
  [channel_type_enum.土耳其Papara]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=120404575
    // 最多10位数字，最少10位数字，第一位不为0
    phone: {
      min: 10,
      max: 10,
      pattern: /\d{10}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
    },
    payee_name: {
      min: 1,
      max: 100,
      pattern: /^(?=.{1,100}$)[^ ].*[^ ]$|^[^ ]$/,
      isTrim: false,
      // formatfn: (val) => val.replace(/[^A-Za-z ]/g, ''),
    },
  },
  [channel_type_enum.巴基斯坦JazzCash]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=120404718
    // 最少10位；最多10位；第一位不为0；第一位需为3；
    phone: {
      min: 10,
      max: 10,
      pattern: /^3\d{9}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
    },
    // 小于100字符英文名 支持“,”，不支持空格
    payee_name: {
      min: 1,
      max: 100,
      pattern: /^[A-Za-z,]{1,100}$/g,
      isTrim: true,
      formatfn: (val) => val.replace(/[^A-Za-z,]/g, ''),
    },
  },
  [channel_type_enum.巴基斯坦Easypaisa]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=120404726
    // 最少10位；最多10位；第一位不为0；第一位需为3；
    phone: {
      min: 10,
      max: 10,
      pattern: /^3\d{9}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
    },
    // 小于100字符英文名 支持“,”，不支持空格
    payee_name: {
      min: 1,
      max: 100,
      pattern: /^[A-Za-z,]{1,100}$/g,
      isTrim: true,
      formatfn: (val) => val.replace(/[^A-Za-z,]/g, ''),
    },
  },
  [channel_type_enum.印尼Doku]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=120404701
    // 最少8位； 最多13位； 第一位不为0； 第一位需为8；
    phone: {
      min: 8,
      max: 13,
      pattern: /^8\d{7,12}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
    },
    // 小于100个字符的英文名称
    payee_name: {
      min: 1,
      max: 100,
      pattern: /^[A-Za-z]{1,100}$/g,
      isTrim: true,
      formatfn: (val) => val.replace(/[^A-Za-z,]/g, ''),
    },
  },
  [channel_type_enum.USDTTRC20]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=127586923
    // 第一位为大写的T，共34位字符（仅限大小写英文字母+阿拉伯数字），其他字符输入不进去
    channel_account: {
      min: 34,
      max: 34,
      pattern: /^T[A-Za-z0-9]{33}$/g,
      formatfn: (val) => val.replace(/[^A-Za-z0-9]/g, ''),
      message: '第三方提现-USDT-报错',
      lable: '第三方提现-USDT',
    },
    // 只能输入 英文字母、半角符号、空格，其他字符输入不进去
    payee_name: {
      min: 1,
      max: 100,
      pattern: /^[a-zA-Z\s,.;:!?()]{1,100}$/g,
      formatfn: (val) => val.replace(/[^a-zA-Z\s,.;:!?()]/g, ''),
    },
  },
  [channel_type_enum.paparaBank]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=155157150
    // 24 位数字
    IBAN: {
      min: 24,
      max: 24,
      pattern: /^\d{24}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
    },
    // 3-100字符 只能包含英文、空格, 空格必须在中间
    payee_name: {
      min: 3,
      max: 100,
      pattern: /^(?=.{3,100}$)(?=.*\s)(?!.*^\s)(?!.*\s$)[A-Za-z\s]+$/,
      formatfn: (val) => val.replace(/[^a-zA-Z ]/g, ''),
    },
  },
  [channel_type_enum.Xendit]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=155157683
    // 只能输入数字，50位以下
    channel_account: {
      min: 1,
      max: 50,
      pattern: /^\d{1,50}$/g,
      formatfn: (val) => val.replace(/[^\d]/g, ''),
    },
    // 0-100字符 允许英文，中划线，空格，点，逗号
    payee_name: {
      min: 1,
      max: 100,
      pattern: /^[a-zA-Z .-]{0,100}$/g,
    },
  },
  [channel_type_enum.PayermaxBankMA]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=156939086#SBB5f%E3%80%81%E6%91%A9%E6%B4%9B%E5%93%A5%E3%80%81%E9%98%BF%E8%81%94%E9%85%8B%E3%80%81%E5%9F%83%E5%8F%8A%E3%80%81%E6%B2%99%E7%89%B9%E9%93%B6%E8%A1%8C%E6%8E%A5%E5%85%A5API-2%E3%80%81%E9%98%BF%E8%81%94%E9%85%8B%E6%8E%A5%E5%85%A5%E6%96%B9%E6%A1%88
    RIB: {
      min: 24,
      max: 24,
      pattern: /^\d{24}$/g,
      formatfn: (val) => val.replace(/[^\d]/g, ''),
    },
    payee_name: {
      min: 0,
      max: 100,
      pattern: /^[a-zA-Z ]{0,100}$/g,
      formatfn: (val) => val.replace(/[^a-zA-Z ]/g, ''),
    },
  },
  [channel_type_enum.PayermaxBankAE]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=156939086#SBB5f%E3%80%81%E6%91%A9%E6%B4%9B%E5%93%A5%E3%80%81%E9%98%BF%E8%81%94%E9%85%8B%E3%80%81%E5%9F%83%E5%8F%8A%E3%80%81%E6%B2%99%E7%89%B9%E9%93%B6%E8%A1%8C%E6%8E%A5%E5%85%A5API-2%E3%80%81%E9%98%BF%E8%81%94%E9%85%8B%E6%8E%A5%E5%85%A5%E6%96%B9%E6%A1%88
    IBAN: {
      min: 21,
      max: 21,
      pattern: /^\d{21}$/g,
      formatfn: (val) => val.replace(/[^\d]/g, ''),
    },
    payee_name: {
      min: 5,
      max: 100,
      pattern: /^(?=.*\s)[A-Za-z\s]{5,100}$/g,
      formatfn: (val) => val.replace(/[^a-zA-Z ]/g, ''),
    },
    address: {
      min: 10,
      max: 100,
      pattern: /^[a-zA-Z0-9 /.-]{10,100}$/g,
      formatfn: (val) => val.replace(/[^a-zA-Z0-9 /.-]/g, ''),
    },
  },
  [channel_type_enum.PayermaxBankSA]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=156939086#SBB5f%E3%80%81%E6%91%A9%E6%B4%9B%E5%93%A5%E3%80%81%E9%98%BF%E8%81%94%E9%85%8B%E3%80%81%E5%9F%83%E5%8F%8A%E3%80%81%E6%B2%99%E7%89%B9%E9%93%B6%E8%A1%8C%E6%8E%A5%E5%85%A5API-2%E3%80%81%E9%98%BF%E8%81%94%E9%85%8B%E6%8E%A5%E5%85%A5%E6%96%B9%E6%A1%88
    IBAN: {
      min: 22,
      max: 22,
      pattern: /^\d{22}$/g,
      formatfn: (val) => val.replace(/[^\d]/g, ''),
    },
    payee_name: {
      min: 5,
      max: 80,
      pattern: /^(?=.*\s)[A-Za-z\s]{5,80}$/g,
      formatfn: (val) => val.replace(/[^a-zA-Z ]/g, ''),
    },
    address: {
      min: 10,
      max: 200,
      pattern: /^[a-zA-Z0-9 /.-]{10,200}$/g,
      formatfn: (val) => val.replace(/[^a-zA-Z0-9\s./-]/g, ''),
    },
  },
  [channel_type_enum.PayermaxBankEG]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=156939086#SBB5f%E3%80%81%E6%91%A9%E6%B4%9B%E5%93%A5%E3%80%81%E9%98%BF%E8%81%94%E9%85%8B%E3%80%81%E5%9F%83%E5%8F%8A%E3%80%81%E6%B2%99%E7%89%B9%E9%93%B6%E8%A1%8C%E6%8E%A5%E5%85%A5API-2%E3%80%81%E9%98%BF%E8%81%94%E9%85%8B%E6%8E%A5%E5%85%A5%E6%96%B9%E6%A1%88
    IBAN: {
      min: 27,
      max: 27,
      pattern: /^\d{27}$/g,
      formatfn: (val) => val.replace(/[^\d]/g, ''),
    },
    payee_name: {
      min: 1,
      max: 50,
      pattern:
        /^[0-9a-zA-Z\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF ,._]{1,50}$/g,
      formatfn: (val) =>
        val.replace(
          /[^0-9a-zA-Z\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF ,._]/g,
          ''
        ),
    },
  },
  [channel_type_enum.PayburgerBankTR]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=164421564
    IBAN: {
      min: 24,
      max: 24,
      pattern: /^\d{24}$/g,
      formatfn: (val) => val.replace(/[^\d]/g, ''),
    },
    payee_part_name: {
      min: 3,
      max: 20,
      pattern: /^[^ \n][^\n]*[^ \n]$|^[^ \n]$/,
    },
    payee_national_id_or_tax_number: {
      min: 11,
      max: 11,
      pattern: /^\d{11}$/g,
      formatfn: (val) => val.replace(/[^\d]/g, ''),
    },
  },
  [channel_type_enum.Pix]: {
    // http://wiki.xunlei.cn/pages/viewpage.action?pageId=174047410
    payee_name: {
      min: 1,
      max: 50,
      // 允许英文字母、葡语重音字符、空格；不允许数字或特殊符号
      pattern: /^\s*[A-Za-zÀ-ÖØ-öø-ÿ]+(?:\s+[A-Za-zÀ-ÖØ-öø-ÿ]+)+\s*$/,
      formatfn: (val) => val.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ\s]/g, ''),
    },
    payee_national_id_or_tax_number: {
      min: 11,
      max: 14,
      pattern: /^(\d{11}|\d{14})$/,
      formatfn: (val) => val.replace(/[^\d]/g, ''),
    },
    phone: {
      min: 11,
      max: 11,
      pattern: /^\d{11}$/g,
      formatfn: (val) => val.replace(/^0|[^\d]/g, ''),
    },
  },
}

export enum bind_channel_type_enum {
  Payoneer = 1,
  PayerMaxBank,
  AirWallexBank,
  PayerMaxFawry,
}

export enum PayonnerTabEnum {
  confirm = 1,
  binding = 2,
}

export enum IdentityTypeEnum {
  身份证 = 1,
  护照 = 2,
}
export enum role_enum {
  公会主 = 1,
  主播,
  普通用户,
}
export enum back_status_enum {
  待审核 = 1,
  审核通过,
  驳回,
}
// 可能绑定的列表
export const bind_type_list = [
  {
    text: 'payonner',
    value: channel_type_enum.Payoneer,
  },
  {
    text: 'payermax_bank',
    value: channel_type_enum.PayerMaxBank,
  },
  {
    text: 'airwallex_bank',
    value: channel_type_enum.AirWallexBank,
  },
  {
    text: 'payermax_fawry',
    value: channel_type_enum.PayerMaxFawry,
  },
]

export const getCountyIndexMap = (arr: Array<config_item>) => {
  if (!arr?.length) {
    return null
  }
  const obj = {}
  arr.forEach((item, index) => {
    obj[item.country_code] = index
  })
  return obj
}

export const IDENTITY_REJECT_REASON = {
  1: '驳回-证件照片与所选的证件类型不符',
  2: '驳回-证件照片模糊',
  3: '驳回-姓名填写错误',
  4: '驳回-证件号填写错误',
  5: '驳回-账号国籍和证件国籍不符',
  6: '驳回-该证件已绑定其他账号',
  7: '驳回-风险身份',
  8: '驳回-其他问题，请联系运营',
}
// 对应op内容 IDENTITY_REJECT_REASON
// [
//   {value: 1, label: '照片与所选的证件类型不符'},
//   {value: 2, label: '照片模糊'},
//   {value: 3, label: '姓名输入错误'},
//   {value: 4, label: '证件号输入错误'},
//   {value: 5, label: '账户国籍和证件国籍不符'},
//   {value: 6, label: '该证件已绑定其他账号'},
//   {value: 7, label: '风险身份'},
//   {value: 8, label: '其他问题，请联系运营'},
// ]

export const Payonner_REJECT_REASON = {
  1: '驳回-Payoneer昵称错误',
  2: '驳回-Payoneer邮箱错误',
  3: '驳回-Payoneer ID错误',
  4: '驳回-Payoneer账号截图错误',
  5: '驳回-其他问题，请联系运营',
}

export const Gcash_REJECT_REASON = {
  1: '驳回-账号截图错误',
  2: '驳回-其他问题，请联系运营',
}

// export const Payoneer_REJECT_REASON = [
//   {value: 1, label: 'Pavoneer Name错误'},
//   {value: 2, label: 'Payoneer Email错误'},
//   {value: 3, label: 'Payoneer ID错误'},
//   {value: 4, label: '截图模糊'},
//   {value: 5, label: '其他问题，请联系运营'},
// ]
// PayerMaxBank支持的国家对应的国家码
export enum PayerMaxBank_county_Enum {
  India = 91,
  Pakistan = 92,
  Indonesia = 62,
  Philippines = 63,
  Thailand = 66,
  Vietnam = 84,
  Malaysia = 60,
  Turkey = 90,
  Egypt = 20,
  Morocco = 212,
  UnitedArabEmirates = 971,
}
export const PayerMaxBank_REJECT_REASON = {
  1: '驳回-银行国家选择错误',
  2: '驳回-银行名称错误',
  3: '驳回-IFSC Code 错误',
  4: '驳回-Swift Code错误',
  5: '驳回-银行卡号输入错误',
  6: '驳回-BAN号输入错误',
  7: '驳回-银行身份声明（RIB）错误',
  8: '驳回-收款人姓名错误',
  9: '驳回-收款人地址错误',
  10: '驳回-收款人电子邮箱错误',
  11: '驳回-收款人手机号错误',
  12: '驳回-其他问题，请联系运营',
}
// export const PayerMaxBank_REJECT_REASON = [
//   {value: 1, label: '银行国家选择错误'},
//   {value: 2, label: '银行名称错误'},
//   {value: 3, label: 'IFSC Code 错误'},
//   {value: 4, label: 'Swift Code错误'},
//   {value: 5, label: '银行卡号输入错误'},
//   {value: 6, label: 'IBAN号输入错误'},
//   {value: 7, label: '银行身份声明(RIB)错误'},
//   {value: 8, label: '收款人姓名错误'},
//   {value: 9, label: '收款人地址错误'},
//   {value: 10, label: '收款人邮箱错误'},
//   {value: 11, label: '收款人手机号错误'},
//   {value: 12, label: '其他问题，请联系运营'},
// ]
// 不是必须填IBAN的国家
export const AirwallexBank_No_IBAN_Country = [
  PayerMaxBank_county_Enum.Indonesia,
  PayerMaxBank_county_Enum.Thailand,
  PayerMaxBank_county_Enum.Vietnam,
]
export const AirwallexBank_REJECT_REASON = {
  1: '驳回-银行国家错误',
  2: '驳回-银行名称错误',
  3: '驳回-银行卡号输入错误',
  4: '驳回-IBAN号输入错误',
  5: '驳回-收款人姓名错误',
  6: '驳回-收款人国家错误',
  7: '驳回-收款人省份错误',
  8: '驳回-收款人城市错误',
  9: '驳回-收款人街道错误',
  10: '驳回-收款人邮编错误',
  11: '驳回-其他问题，请联系运营',
}
// export const AirwallexBank_REJECT_REASON = [
//   {value: 1, label: '银行国家选择错误'},
//   {value: 2, label: '银行名称错误'},
//   {value: 3, label: '银行卡号输入错误'},
//   {value: 4, label: 'IBAN号输入错误'},
//   {value: 5, label: '收款人姓名错误'},
//   {value: 6, label: '收款人国家错误'},
//   {value: 7, label: '收款人省份错误'},
//   {value: 8, label: '收款人城市错误'},
//   {value: 9, label: '收款人街道错误'},
//   {value: 10, label: '收款人邮编错误'},
//   {value: 11, label: '其他问题，请联系运营'},
// ]
export const PayerMaxFawry_REJECT_REASON = {
  1: '驳回-收款人国家错误',
  2: '驳回-收款人手机号错误',
  3: '驳回-收款人电子邮箱错误',
  4: '驳回-其他问题，请联系运营',
}
// export const PayerMaxFawry_REJECT_REASON = [
//   {value: 1, label: '收款人国家错误'},
//   {value: 2, label: '收款人手机号错误'},
//   {value: 3, label: '收款人邮箱地址错误'},
//   {value: 4, label: '其他问题，请联系运营'},
// ]

export const goUrl = (url: string) => {
  if (url) {
    window.HiyaJSBridge.callHandler('openScheme', {
      url: `hiya://openWindow?fullscreen=0&external=0&need_user_info=0&url=${url}`,
    })
  }
}
// 直接绑定他人账号
export const goPayoneerOther = () => {
  const url = `hiya://openWindow?fullscreen=${0}&bg_clear=1&alert_h_ratio=0.8&external=0&need_user_info=1&close_current=${1}&other_info=${encodeURIComponent(
    JSON.stringify({channel_type: channel_type_enum.Payoneer})
  )}&url=${HiyaVerHost}/union/GatherInfo/PayoneerOther`
  window.HiyaJSBridge.callHandler('openScheme', {
    url,
  })
}
export const goPayoneerNew = (otherInfo = {}) => {
  const url = `hiya://openWindow?fullscreen=${0}&bg_clear=1&alert_h_ratio=0.8&external=0&need_user_info=1&close_current=${1}&other_info=${encodeURIComponent(
    JSON.stringify({channel_type: channel_type_enum.Payoneer, ...otherInfo})
  )}&url=${HiyaVerHost}/union/GatherInfo/PayoneerNew`
  window.HiyaJSBridge.callHandler('openScheme', {
    url,
  })
}
// 生成链接绑定他人
export const goPayoneerOtherLink = () => {
  const url = `hiya://openWindow?fullscreen=${0}&bg_clear=1&alert_h_ratio=0.8&external=0&need_user_info=1&close_current=${1}&other_info=${encodeURIComponent(
    JSON.stringify({channel_type: channel_type_enum.Payoneer})
  )}&url=${HiyaVerHost}/union/GatherInfo/PayoneerOther/Link`
  window.HiyaJSBridge.callHandler('openScheme', {
    url,
  })
}
// 第三方验证码的绑定渠道
export enum vcode_channel {
  短信 = 0,
  语音,
  WhatsApp,
}

export enum ChannelAccountTypePhoneEnum {
  ChannelAccountTypePhone = 'PHONE',
  ChannelAccountTypeEmail = 'EMAIL',
  ChannelAccountTypeCPF = 'CPF',
  ChannelAccountTypeEVP = 'EVP',
}
